/**
 * Job Source Utilities
 *
 * Utilities for formatting and displaying job source fields
 */

/**
 * Strip timestamp suffix from job source field
 *
 * Jobs may have trailing timestamps appended to their source field
 * in the format: "source#timestamp"
 *
 * @param source - Job source field (e.g., "portscan#1234567890")
 * @returns Source without timestamp (e.g., "portscan")
 *
 * @example
 * ```ts
 * stripJobSourceTimestamp("portscan#1234567890") // "portscan"
 * stripJobSourceTimestamp("portscan") // "portscan"
 * ```
 */
export const stripJobSourceTimestamp = (source: string): string => {
  const hashIndex = source.indexOf('#');
  return hashIndex !== -1 ? source.substring(0, hashIndex) : source;
};
